const Blockly = require('blockly');

const TOOLTIP = 'DEPRECATED - please use menus > Menu instead';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);

    blocklyBlock.setPreviousStatement(false);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);
    blocklyBlock.appendStatementInput('children').appendField('Children:', 'childrenField');
    // 4/1/2024 can't disable this block until ALL the RN apps are updated to use the Menu block
    // until then, we are going to allow the menu to follow this block, and have the new UI ignore this one.
    blocklyBlock.setNextStatement(true);
    // blocklyBlock.setEnabled(false);
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
